import React  from 'react';

export default function renderListGroupTListHeader1(id, props) {
    const customField = gd.session.customFields.get(id)
    const item = _.find(customField.params.listItems, i=>i.id == props.data.value) // == is intentional to make no difference between string and number

    const classes = Classes("text", "ui5-txt-default", item && !_.isNil(item.color) ? 'gd-c-font-{0}'.f(item.color) : null)

    return <div className={classes}>{item ? item.value : "Not selected"}</div>;
}